import { Grid, Switch, Typography } from '@mui/material';
import { ToggleExactMatch } from 'src/components/input/searchBarWithBadges/SearchBarWithBadges.styled';
import { IOwnerOperatorTagsSectionProps } from 'src/interfaces';
import { lang } from 'src/utils';

import { Divider } from '../../DetailLocationPage.styled';

export const OwnerOperatorTagsSection = ({
  isBannerEnabled,
  isMessagingEnabled,
  setIsBannerEnabled,
  setIsMessagingEnabled,
  setIsBannerChanged,
  setIsMessagingChanged,
  isBannerChanged,
  isMessagingChanged,
}: IOwnerOperatorTagsSectionProps) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h4">
          {lang.ownerOperator.ownerOperatorTags}
        </Typography>
        <Divider $marginBottom={15} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h4">{lang.ownerOperator.CODMessaging}</Typography>
        <Divider $marginBottom={15} />
        <ToggleExactMatch>
          <Typography variant="body1" fontWeight={400}>
            {lang.banner}
          </Typography>
          <Switch
            checked={isBannerEnabled}
            onChange={() => {
              setIsBannerEnabled(!isBannerEnabled);
              setIsBannerChanged(!isBannerChanged);
            }}
          />
        </ToggleExactMatch>
        <ToggleExactMatch>
          <Typography variant="body1" fontWeight={400}>
            {lang.messaging}
          </Typography>
          <Switch
            checked={isMessagingEnabled}
            onChange={() => {
              setIsMessagingEnabled(!isMessagingEnabled);
              setIsMessagingChanged(!isMessagingChanged);
            }}
          />
        </ToggleExactMatch>
      </Grid>
    </>
  );
};
